import { concatMap, map, mergeMap } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { invoiceCommand } from '../../command/unpaid-invoice';
import { RegisterPaymentFormComponent } from '../../component/register-payment-form/register-payment-form.component';
import { Invoice } from '../../model/invoice';
import { Observable } from 'rxjs';
import { SelectDateDialogComponent } from '../../../common/component/select-date-dialog/select-date-dialog.component';
import { LocalDate } from '../../../core/model/local-date';
import { InvoiceService } from '../data/invoice.service';

@Injectable()
export class SetDefermentDateCommandHandler implements ICommandHandler {
  constructor(
    private _actionWindowservice: ActionWindowService,
    private _injector: Injector,
    private _invoiceService: InvoiceService
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command && command.context instanceof Invoice) {
      return command.id === invoiceCommand.setDefermentDate;
    }
    return false;
  }

  execute(command: CommandBase): Observable<boolean> {
    if (command instanceof Command) {
      let defaultValue = LocalDate.fromDate(command.context.defermentDate);
      if (!defaultValue.hasValue()) defaultValue = LocalDate.fromDate(LocalDate.fromDate(command.context.dueDate).addMonths(1));

      return this._actionWindowservice
        .open(SelectDateDialogComponent, this._injector, null, {
          fieldName: 'INVOICE.DEFERMENT_DATE',
          helpText: 'INVOICE.HELP_TEXT.DEFERMENT_DATE',
          title: 'INVOICE.EDIT_DEFERMENT_DATE',
          defaultValue: defaultValue,
        })
        .pipe(
          concatMap(
            value => this._invoiceService.setDefermentDate(command.context.id, value.value),
            value => {
              command.context.defermentDate = value.value;
              return true;
            }
          )
        );
    }
  }
}
